export const SAVE_CENSUS_EVENT = 'retira:save-census'
export const LOAD_CENSUS_EVENT = 'retira:load-census'
export const LOAD_EXAMPLE_CENSUS_EVENT = 'retira:load-example-census'
